import isEqual from 'react-fast-compare';

import { createReducerTypeSafe } from '@/utils/redux';

import {
  storeClearTransactions,
  StoreInitActionPayload,
  storeInitialized,
  storeLastReload,
  StoreLastReloadActionPayload,
  storeLogout,
  storeTransactions,
  StoreTransactionsActionPayload,
  storeTransactionsFilter,
  storeWallets,
  StoreWalletsActionPayload,
} from './actions';
import { AnyTransactionPeriod, initialState, State } from './types';

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storeInitialized,
    (state: State, { wallets: { selected, all } }: StoreInitActionPayload): State =>
      state.initialized ? state : { ...initialState, wallets: all, selectedWallet: selected, initialized: true },
  ],
  [storeClearTransactions, (state: State): State => ({ ...state, transactions: undefined })],
  [
    storeTransactions,
    (state: State, { data, hasMore, lastPage }: StoreTransactionsActionPayload): State => ({
      ...state,
      transactions: {
        hasMore,
        lastPage,
        data: [
          ...((state.transactions?.lastPage && state.transactions.lastPage < lastPage
            ? state.transactions?.data
            : []) || []),
          ...data,
        ],
      },
      lastReload: { ...state.lastReload, transactions: new Date() },
    }),
  ],
  [
    storeWallets,
    (state: State, { all, selected }: StoreWalletsActionPayload): State =>
      isEqual(state.wallets, all) && isEqual(state.selectedWallet, selected)
        ? state
        : {
            ...state,
            wallets: all,
            selectedWallet: selected,
          },
  ],
  [
    storeTransactionsFilter,
    (state: State, filter: AnyTransactionPeriod): State =>
      isEqual(state.transactionsFilter, filter) ? state : { ...state, transactionsFilter: filter },
  ],
  [
    storeLastReload,
    (state: State, { type, value }: StoreLastReloadActionPayload): State => ({
      ...state,
      lastReload: { ...state.lastReload, [type]: value },
    }),
  ],
  [storeLogout, (): State => ({ ...initialState, initialized: true })],
]);

export default reducers;
